var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopUpBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1626_11688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 64C53.6731 64 68 49.6731 68 32C68 14.3269 53.6731 0 36 0C18.3269 0 4 14.3269 4 32C4 49.6731 18.3269 64 36 64Z",
    fill: "#FFF3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 16C34.4477 16 34 16.4477 34 17V19C34 19.5523 34.4477 20 35 20V20C35.5523 20 36 19.5523 36 19V17C36 16.4477 35.5523 16 35 16V16Z",
    fill: "#FFC542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3587 23.3587C25.7129 23.0045 25.7129 22.4303 25.3587 22.0761L23.9239 20.6413C23.5697 20.2871 22.9955 20.2871 22.6413 20.6413V20.6413C22.2871 20.9955 22.2871 21.5697 22.6413 21.9239L24.0761 23.3587C24.4303 23.7129 25.0045 23.7129 25.3587 23.3587V23.3587Z",
    fill: "#FFC542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6413 23.3587C44.9955 23.7129 45.5697 23.7129 45.9239 23.3587L47.3587 21.9239C47.7129 21.5697 47.7129 20.9955 47.3587 20.6413V20.6413C47.0045 20.2871 46.4303 20.2871 46.0761 20.6413L44.6413 22.0761C44.2871 22.4303 44.2871 23.0045 44.6413 23.3587V23.3587Z",
    fill: "#FFC542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0005 22C34.0798 21.9996 32.2235 22.756 30.7725 24.1301C29.3215 25.5042 28.3733 27.4038 28.1021 29.48L28.0819 29.634C27.9288 30.7906 27.9908 31.9691 28.2643 33.099C28.5378 34.2288 29.0172 35.2868 29.6737 36.2098C30.4454 37.2988 30.9633 38.3394 30.9633 39.3822V42.9C30.9633 43.1917 31.0694 43.4715 31.2583 43.6778C31.4473 43.8841 31.7035 44 31.9707 44H40.0304C40.2976 44 40.5538 43.8841 40.7428 43.6778C40.9317 43.4715 41.0378 43.1917 41.0378 42.9V39.3822C41.0378 38.3394 41.5557 37.2988 42.3274 36.2098C43.5968 34.419 44.2375 32.0848 43.9192 29.6318L43.899 29.4778C43.6274 27.402 42.679 25.503 41.2281 24.1293C39.7771 22.7556 37.921 21.9996 36.0005 22V22Z",
    fill: "#FFC542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 31C20 31.5523 20.4477 32 21 32H23C23.5523 32 24 31.5523 24 31V31C24 30.4477 23.5523 30 23 30H21C20.4477 30 20 30.4477 20 31V31Z",
    fill: "#FFC542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 31C48 31.5523 48.4477 32 49 32H51C51.5523 32 52 31.5523 52 31V31C52 30.4477 51.5523 30 51 30H49C48.4477 30 48 30.4477 48 31V31Z",
    fill: "#FFC542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 47C32 47.5523 32.4477 48 33 48H37C37.5523 48 38 47.5523 38 47V47C38 46.4477 37.5523 46 37 46H33C32.4477 46 32 46.4477 32 47V47Z",
    fill: "#FFC542"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 8,
    r: 8,
    fill: "#FC5A5A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1626_11688",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.298039 0 0 0 0 0.972549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1626_11688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1626_11688",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopUpBulb);
export default __webpack_public_path__ + "static/media/pop-up-bulb.5ecf1276.svg";
export { ForwardRef as ReactComponent };